import { FormEvent } from 'react';
import { Error } from '@components/error/src/error';
import { Input } from '@components/input';
import classNames from 'classnames';

import { ChannelLimitInputProps } from './channel-limit-input.type';

export const ChannelLimitInput = ({
  name,
  value,
  onChange,
  hasError = false,
  errorMessage,
  disabled = false,
  placeholder = '∞',
  testId,
}: ChannelLimitInputProps) => {
  const handleChange = (e: FormEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value);
  };

  const channelTestId = `channel-${testId}`;

  return (
    <div data-testid={testId}>
      <div className='flex items-center'>
        <div className='w-20'>
          <Input
            type='number'
            step={1}
            min={1}
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            hasError={hasError}
            disabled={disabled}
            id={channelTestId}
          />
        </div>
        <label
          htmlFor={channelTestId}
          className={classNames('ml-3 text-sm text-ellipsis', {
            'text-tertiary': disabled,
            'text-primary dark:text-white': !disabled,
          })}>
          {name}
        </label>
      </div>
      {hasError && errorMessage && <Error className='mt-1 ml-0'>{errorMessage}</Error>}
    </div>
  );
};
